const s3url = "https://magical-trip.s3.ap-northeast-1.amazonaws.com/";

const defaultTransformation = {
  autoFormat: true,
  autoQuality: true,
  fill: true,
} as const;

export function getCloudinaryUrl(
  type: "image" | "video",
  url: string,
  transformations?: Transformation | Transformation[],
  applyDefaultTransformation: boolean = true,
  cloudName: string = "dbm1qiew0"
) {
  if (!url) return "";

  const cloudinaryUrl = `https://res.cloudinary.com/${cloudName}`;

  // coalesce transformation into an array
  const transformationsAsArray =
    transformations === undefined
      ? [{}]
      : transformations instanceof Array
      ? transformations
      : [transformations];

  // if apply default transformation it true, apply it to the first transformation
  if (applyDefaultTransformation)
    transformationsAsArray[0] = {
      ...transformationsAsArray[0],
      ...defaultTransformation,
    };

  const transformationQuery = transformationsAsArray
    .map(parseTransformation)
    .join("/");

  if (url.includes(s3url)) {
    const media = url.split(s3url)[1];
    return `${cloudinaryUrl}/${type}/upload/${transformationQuery}/s3bucket/${media}`;
  } else if (url.includes(cloudinaryUrl) && url.includes("/upload/")) {
    return url.replace(
      `/${cloudName}/${type}/upload/`,
      `/${cloudName}/${type}/upload/${transformationQuery}/`
    );
  } else {
    return `${cloudinaryUrl}/${type}/upload/${transformationQuery}/${url}`;
  }
}

const parseTransformation = (transformation: Transformation) => {
  const transformationMap: {
    [key in keyof Required<Transformation>]: (args: any) => string;
  } = {
    width: (width: number) => `w_${width}`,
    height: (height: number) => `h_${height}`,
    autoFormat: (autoFormat: boolean) => (autoFormat ? `f_auto` : ""),
    autoQuality: (autoQuality: boolean) => (autoQuality ? `q_auto` : ""),
    autoWidth: (autoWidth: boolean) => (autoWidth ? `w_auto` : ""),
    autoHeight: () => "",
    circle: (circle: boolean) => (circle ? "r_max" : ""),
    fill: (fill: boolean) => (fill ? "c_fill" : ""),
  };

  const transformationQuery = Object.entries(transformation)
    .filter(([_, args]) => args !== null && args !== undefined)
    .map(([key, args]) => transformationMap[key as keyof Transformation](args))
    .filter(Boolean)
    .join(",");

  return transformationQuery;
};

export type Transformation = {
  width?: number;
  height?: number;
  autoWidth?: boolean;
  autoHeight?: boolean;
  autoFormat?: boolean;
  autoQuality?: boolean;
  circle?: boolean;
  fill?: boolean;
};
